import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">读者热评</h2>
          <p className="text-sm text-foreground-500">看看吃瓜群众们怎么说</p>
        </div>

        <div className="space-y-4">
          {commentItems.map((comment) => (
            <div key={comment.name} className="p-5 rounded-xl bg-background-100 border border-background-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 mt-2 leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-thumb-up-line"></i>
                      {comment.likes}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}